import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=0fe8fe3e&scoped=true&"
import script from "./BottomFooter.vue?vue&type=script&lang=js&"
export * from "./BottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./BottomFooter.vue?vue&type=style&index=0&id=0fe8fe3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe8fe3e",
  null
  
)

export default component.exports